import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import api from "../api";
import "../styles/SignInPage.css";
import "../styles/buttons.css";

export default function SetPasswordPage() {
  const [pwd1, setPwd1] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [banner, setBanner] = useState("");
  const [working, setWorking] = useState(false);

  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("sign-in-body");
    return () => document.body.classList.remove("sign-in-body");
  }, []);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setBanner("Invalid link – please request a new one.");
    }
  }, [params]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = params.get("token");

    if (!token) {
      return setBanner("Invalid link – please request a new one.");
    }
    if (pwd1.length < 8) {
      return setBanner("Password must be at least 8 characters.");
    }
    if (pwd1 !== pwd2) {
      return setBanner("Passwords do not match.");
    }

    try {
      setWorking(true);
      const { data } = await api.post(
        "/set_password/",
        { token, password: pwd1 },
        { withCredentials: true }
      );
      if (data.cookie) {
        localStorage.setItem("bd2mSessionToken", data.cookie);
      }
      setBanner("Password saved! Redirecting…");
      setTimeout(() => navigate(`/dashboard/${data.user_id}`), 1200);
    } catch (err) {
      console.error(err);
      setBanner(err?.response?.data?.message || "Could not set password – please try again.");
    } finally {
      setWorking(false);
    }
  };

  return (
    <div className="sign-in-body">
      <div className="sign-in-container">
        <div className="logo">
          <a href="/">BestDay2Marry</a>
        </div>

        <div className="sign-in-form">
          <h1>Create Password</h1>

          {banner && (
            <div
              className={banner.startsWith("Password saved") ? "success-message" : "error-message"}
              style={{ marginBottom: 16 }}
            >
              {banner}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <input
                type="password"
                placeholder="New password"
                value={pwd1}
                onChange={(e) => setPwd1(e.target.value)}
              />
            </div>

            <div className="form-group">
              <input
                type="password"
                placeholder="Confirm password"
                value={pwd2}
                onChange={(e) => setPwd2(e.target.value)}
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={working}>
              {working ? "Saving…" : "Save password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
